import { render, staticRenderFns } from "./WaiverPdfDocument.vue?vue&type=template&id=01bf6d8f&scoped=true"
import script from "./WaiverPdfDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaiverPdfDocument.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WaiverPdfDocument.vue?vue&type=style&index=0&id=01bf6d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bf6d8f",
  null
  
)

export default component.exports